module.exports = __webpack_public_path__ + "img/shirt-02.b6828d53.png";